module.exports = __webpack_public_path__ + "media/images/country_flags/va-6dc5919cc233106f285066fc3a36af53.png";